import React, { Component } from "react";
import { withAppState } from "../../state";
import {
  CatchupEpgStyled,
  TimeStyled,
  DateStyled,
  TimeListStyled,
  TimeSlotStyled,
  TimeRulerStyled,
  TimesSlotDiv,
  TimeTextStyled,
  EpgContainer,
  LayoutEmptyStyledEPG,
  BarTimeStyled
} from "./viewStyles/Styled";
import { Text } from "../../services/visualLibraryService";
import { directions, i18n } from "../../services/i18nService";
import DynamicEpg from "./DynamicEpg";
const TIME_TO_MILLISECONDS = 1000;
const PIXELS_TO_REM = 16; // for EPG
const SECONDS_PER_PIXELS = 8;
const SECONDS_IN_HOUR = 3600;
const TOTAL_TIME_HOURS = 15;
const SECONDS_IN_MINUTES = 60;
const HOURS_IN_A_DAY = 24;
const ONE_MINT_MILLISECONDS = 60000;
const CURRENT_TIMELINE = "current";
const PADDING_AT_START = 16;

class DynamicEpgView extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      dynamicData: props.data,
      timeSlots: [],
      lineBarLeftDistance: 0
    };
    this.startEpgDate = 0;
    this.remWidthPerMinute = 0;
    this.remWidthPerHour = 0;
    this.clearBarTimeout = null;
    this.timeBarInterval = null;
    this.minutesOffset = null;
    this.timelineWidth = null;
    this.currentTimeSlot = null;
  }

  async componentDidMount() {
    this.getREMWidthPerHour();
    this.getREMWidthPerMinute();
    this.onMoveLineBar();
    let d = new Date();
    if (this.state.dynamicData) {
      this.createTimeSlots();
      this.setState({
        currentSlot: d.getHours() < 10 ? `0${d.getHours()}:00` : `${d.getHours()}:00`
      });
    }
  }
  async componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.currentCol !== this.props.currentCol ||
      prevProps.currentRow !== this.props.currentRow ||
      prevProps.categoryIndex !== this.props.categoryIndex ||
      prevProps.currentLiveIndex !== this.props.currentLiveIndex
    ) {
      this.setState({
        currentSlot: this.getCurrentTimeSlot()
      });
    }
  }

  componentWillUnmount() {
    this.clearBarTimeout && clearTimeout(this.clearBarTimeout);
    this.timeBarInterval && clearInterval(this.timeBarInterval);
    this.clearBarTimeout = null;
    this.timeBarInterval = null;
    document.removeEventListener("keydown", this.navigation, false);
  }

  createTimeSlots() {
    const d = new Date(this.props.epgStartDate * TIME_TO_MILLISECONDS);
    let hours = d.getHours();
    const timeSlots = [];
    for (var i = 0; i < TOTAL_TIME_HOURS; i++) {
      timeSlots.push(hours < 10 ? `0${hours}:00` : `${hours}:00`);
      if (TOTAL_TIME_HOURS > 15) {
        hours < TOTAL_TIME_HOURS - 1 ? (hours > 22 ? (hours = 0) : (hours += 1)) : (hours = 0);
      } else {
        hours > 22 ? (hours = 0) : (hours += 1);
      }
    }
    this.setState(
      {
        timeSlots: timeSlots
      },
      () => {
        this.timelineWidth = document.querySelector(".timeline ul").offsetWidth;
        this.currentTimeSlot = document.querySelector(".current").offsetWidth;
      }
    );
  }

  getREMWidthPerMinute = () => {
    const remLength = parseFloat(this.remWidthPerHour / SECONDS_IN_MINUTES);
    this.remWidthPerMinute = remLength;
    return remLength;
  };

  getREMWidthPerHour = () => {
    const remLength = parseFloat(parseFloat(SECONDS_IN_HOUR / SECONDS_PER_PIXELS) / PIXELS_TO_REM);
    this.remWidthPerHour = remLength;
    return remLength;
  };

  rulerPerSecond = () => {
    return parseFloat(parseFloat(SECONDS_IN_HOUR / SECONDS_PER_PIXELS) / PIXELS_TO_REM);
  };

  getCurrentTimeSlot = () => {
    const currentTime = this.props.data[this.props.currentCat]?.data[this.props.currentRow]?.events[
      this.props.currentCol
    ]?.tsStart;
    const d = new Date(currentTime * TIME_TO_MILLISECONDS);
    let currentHours = d.getHours();
    this.minutesOffset = d.getMinutes();
    return currentHours < 10 ? `0${currentHours}:00` : `${currentHours}:00`;
  };

  convertMinutesIntoPixels = () => {
    const seconds = this.minutesOffset * 60;
    return seconds / SECONDS_PER_PIXELS;
  };

  onMoveLineBar() {
    const time = new Date();
    const secondsRemaining = (60 - time.getSeconds()) * 1000;
    const self = this;

    this.clearBarTimeout = setTimeout(function() {
      self.setLineBarDistance(self);
      self.timeBarInterval = setInterval(() => {
        self.setLineBarDistance(self);
      }, ONE_MINT_MILLISECONDS);
    }, secondsRemaining);
  }

  setLineBarDistance(self) {
    const distance = self.getLiveBarTimeline();
    self.setState({ lineBarLeftDistance: distance });
  }

  getLiveBarTimeline = () => {
    const todayDate = new Date();
    const startDate = new Date(this.props.epgStartDate * TIME_TO_MILLISECONDS);
    let differenceHours;
    differenceHours = todayDate.getHours() - startDate.getHours();
    if (differenceHours < 0) {
      // if we are getting time of previous day
      const addPastHours = HOURS_IN_A_DAY - startDate.getHours();
      differenceHours = todayDate.getHours() + addPastHours;
    }
    // to move the bar to the start of live program slot
    const totalRemWidthHours = differenceHours * this.remWidthPerHour;
    // to move the bar from start of the program to current time in minutes
    const totalRemWidthMinutes = todayDate.getMinutes() * this.remWidthPerMinute;
    const totalRemWidth = totalRemWidthHours + totalRemWidthMinutes;
    return totalRemWidth;
  };

  render() {
    const {
      currentDate,
      onChange,
      currentView,
      changeViewRowIndex,
      visibleRows,
      visibleCat,
      currentRowIndex,
      categoryIndex,
      currentVideoMetaData,
      data,
      isFullScreen,
      currentLiveIndex,
      wheelState,
      actions,
      onUpdateWheelState,
      onClickEpgSlots
    } = this.props;
    const { lineBarLeftDistance, timeSlots } = this.state;
    const direction = i18n.getDirection();
    return (
      <CatchupEpgStyled direction={direction}>
        <DateStyled direction={direction}>{currentDate}</DateStyled>
        <TimeStyled direction={direction}>
          <TimeRulerStyled className={"timeline"} direction={direction}>
            <TimeListStyled direction={direction}>
              <BarTimeStyled
                direction={direction}
                move={lineBarLeftDistance === 0 ? this.getLiveBarTimeline() : lineBarLeftDistance}
              />
              {timeSlots.map((item, index) => (
                <TimeSlotStyled
                  key={`TimeSlotStyled-${index}`}
                  ruler={this.rulerPerSecond()}
                  direction={direction}
                  className={item === this.state.currentSlot && CURRENT_TIMELINE}
                >
                  <TimesSlotDiv direction={direction}>
                    <TimeTextStyled direction={direction}>{item}</TimeTextStyled>
                  </TimesSlotDiv>
                </TimeSlotStyled>
              ))}
            </TimeListStyled>
          </TimeRulerStyled>
        </TimeStyled>
        <EpgContainer direction={direction}>
          {data.length !== 0 ? (
            <DynamicEpg
              dynamicData={data}
              onChange={onChange}
              currentView={currentView}
              changeViewRowIndex={changeViewRowIndex}
              currentLiveIndex={currentLiveIndex}
              isFullScreen={isFullScreen}
              visibleRows={visibleRows}
              visibleCat={visibleCat}
              currentRowIndex={currentRowIndex}
              categoryIndex={categoryIndex}
              currentVideoMetaData={currentVideoMetaData}
              wheelState={wheelState}
              actions={actions}
              onUpdateWheelState={onUpdateWheelState}
              onClickEpgSlots = {onClickEpgSlots}
            />
          ) : (
            <LayoutEmptyStyledEPG>
              <strong>
                <Text text={i18n.get("pages.livePage.noData.emptyDataMsg")} />
              </strong>
              <Text text={i18n.get("pages.livePage.noData.emptyDataSubMsg")} />
            </LayoutEmptyStyledEPG>
          )}
        </EpgContainer>
      </CatchupEpgStyled>
    );
  }
}
export default withAppState(DynamicEpgView);
